import { Box, Button, Stack, Tab, Tabs } from "@mui/material";
import { retrieveSingleSpecialist } from "../../../../redux/admin-slices/specialist.slice";
import { REJECT_SPECIALIST, VERIFY_SPECIALIST, } from "../../../../utils/keywords";
import { showDialogWithData } from "../../../../redux/guest-slices/other.slice";
import TabPanel from "../../../../components/common/TabPanel";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Professional from "./Professional";
import TrustSafety from "./TrustSafety";
import Expertise from "./Expertise";

function Details() {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const [value, setValue] = useState("expertise");
  const [specialist, setSpecialist] = useState({});
  const handleChange = (_, newValue) => {
    setValue(newValue);
  };
  const { refresh } = useSelector((state) => state.otherSlice);

  // Handle retrieve specialist
  const handleGet = () => {
    dispatch(retrieveSingleSpecialist(userId))
      .unwrap()
      .then((data) => {
        setSpecialist(data?.specialist);
      })
      .catch(() => { });
  };

  // handle verify
  const handleVerify = (states) => {
    states === "verify"
      ? dispatch(
        showDialogWithData({
          type: VERIFY_SPECIALIST,
          data: { specialistId: userId },
        })
      )
      : dispatch(
        showDialogWithData({
          type: REJECT_SPECIALIST,
          data: { specialistId: userId },
        })
      );
  };

  useEffect(() => {
    handleGet();
    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          p: 3,
          width: "100%",
          overflow: "hidden",
          borderRadius: "12px",
          bgcolor: "white",
          border: "1px solid #00000012",
        }}
      >
        <Box >
          <Tabs
            value={value}
            variant="scrollable"
            onChange={handleChange}
            sx={{ button: { fontFamily: "Poppins" } }}
          >
            <Tab label="User Expertise" value="expertise" />
            <Tab label="Trust & safety" value="trust-safety" />
            <Tab label="Professional profile" value="professional-profile" />
          </Tabs>
        </Box>

        <Box sx={{ pt: 3 }}>
          <TabPanel
            value="expertise"
            index={value}
            children={<Expertise expertise={specialist?.expertise} />}
          />
          <TabPanel
            value="trust-safety"
            index={value}
            children={<TrustSafety specialist={specialist} />}
          />
          <TabPanel
            value="professional-profile"
            index={value}
            children={<Professional specialist={specialist} />}
          />
        </Box>

        {specialist?.vereification?.currentStep === "confirmation" && (
          <Stack spacing={2} direction="row" mt={3}>
            {specialist?.vereification?.status === "pending" ? (
              <>
                <Button
                  color="success"
                  variant="contained"
                  onClick={() => {
                    handleVerify("verify");
                  }}
                >
                  Verify User
                </Button>
                <Button
                  color="error"
                  variant="contained"
                  onClick={() => {
                    handleVerify("reject");
                  }}
                >
                  Reject User
                </Button>
              </>
            ) : (
              <Button disableRipple variant="contained" sx={{ cursor: "auto" }}>
                User Verified
              </Button>
            )}
          </Stack>
        )}
      </Box>
    </Box>
  );
}

export default Details;
